export const TableHeaders = [
  { column: 'clientName', label: 'Client Name', width: '18%', sortBy: 'text' },
  { column: 'patientName', label: 'Patient Name', width: '18%', sortBy: 'text' },
  { column: 'message', label: 'Message', width: '32%', sortBy: 'text' },
  { column: 'scheduledAt', label: 'Scheduled At', width: '12%', sortBy: 'value' },
  { column: 'createdAt', label: 'Created At', width: '10%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '10%' },
];
